interface TitleProps {
  children: React.ReactNode;
  className?: string;
}

export const Title = (props: TitleProps) => {
  const { className, children } = props;

  return <h2 className={className}>{children}</h2>;
};
